export default __webpack_public_path__ + "assets/images/abf6fb860e59ec714749c19ab7b15d46.svg";